import { convertKeysToLowerCase } from '@/lib/utils/objects';
import { RateProviders } from '../types';

// TODO: Need to check

const rateProviders: RateProviders = {
  '*': {
    '0x0000000000000000000000000000000000000000': true,
  },
};

export default convertKeysToLowerCase(rateProviders);
